import GetOffset from '../_utils/GetOffset';

const TRANSITION_DURATION = 1000;
const AUTOPLAY_DURATION = 8000;

export default class Testimonial {


	// Constructor
	constructor(element) {
		this.element = element;

		this.buttonClick = this.buttonClick.bind(this);
		this.timerFired = this.timerFired.bind(this);

		this.buttonNext = this.element.querySelector('.paged-buttons--next');
		this.buttonPrev = this.element.querySelector('.paged-buttons--prev');
		this.images = Array.prototype.slice.call(this.element.querySelectorAll('.section-testimonials--img'), 0);
		this.items = Array.prototype.slice.call(this.element.querySelectorAll('.section-testimonials--item'), 0);
		this.numberCurrent = this.element.querySelector('.paged-buttons--total strong');
		this.numberTotal = this.element.querySelector('.paged-buttons--total span');

		this.buttonNext.addEventListener('click', this.buttonClick);
		this.buttonPrev.addEventListener('click', this.buttonClick);

		this.clickEnabled = true;
		this.index = -1;
		this.scrollEnabled = true;
		this.scrollMin = -1;

		this.autoPlayInterval = null;
	}


	// Public Methods
	changeCard(index) {

		if (this.clickEnabled === false) {
			return;
		}

		if (index !== this.index && index >= 0 && index < this.items.length) {
			const prev = this.index;
			this.index = index;

			if (prev !== -1) {
				this.images[prev].classList.add('previous');
				this.images[prev].classList.remove('current');
				this.items[prev].classList.add('previous');
				this.items[prev].classList.remove('current');
			} else {
				this.items[this.index].classList.add('current');
			}
			this.images[this.index].classList.add('current');

			this.buttonNext.classList.remove('is-disabled');
			this.buttonPrev.classList.remove('is-disabled');
			if (this.index === this.items.length - 1) {
				this.buttonNext.classList.add('is-disabled');
			}
			if (this.index === 0) {
				this.buttonPrev.classList.add('is-disabled');
			}

			this.numberCurrent.innerHTML = this.displayNumber(this.index + 1);
			this.numberTotal.innerHTML = this.displayNumber(this.items.length);

			this.clickEnabled = false;
			setTimeout(this.timerFired, TRANSITION_DURATION);
		}
	}
	resize() {
		if (this.scrollEnabled) {

			const elementTop = GetOffset.top(this.element);
			const elementHeight = this.element.offsetHeight;
			const windowHeight = window.innerHeight;
			this.scrollMin = elementTop + elementHeight - windowHeight;

			if (elementHeight >= windowHeight) {
				this.scrollMin = elementTop;
			}

			this.scrollMin -= windowHeight / 2;

			this.scroll();
		}
	}
	scroll() {
		if (this.scrollEnabled && this.scrollMin !== -1) {
			const scrollY = window.pageYOffset;
			if (scrollY >= this.scrollMin) {
				this.element.classList.add('play');
				this.scrollEnabled = false;
				this.changeCard(0);
				this.startAutoplay();
			}
		}
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();

		this.stopAutoplay();

		if (event.currentTarget === this.buttonPrev) {
			this.changeCard(this.index - 1);
		} else {
			this.changeCard(this.index + 1);
		}
	}
	timerFired() {
		for (var i=0, l=this.items.length; i<l; i++) {
			if (this.index !== i) {
				this.images[i].classList.remove('previous');
				this.images[i].classList.remove('current');
				this.items[i].classList.remove('previous');
				this.items[i].classList.remove('current');
			} else {
				this.items[i].classList.add('current');
			}
		}

		this.clickEnabled = true;
	}

	startAutoplay() {
		this.autoPlayInterval = setInterval(() => {

			let nextIndex = this.index + 1;
			if (nextIndex > (this.items.length - 1)) {
				nextIndex = 0;
			}

			this.changeCard(nextIndex);
		}, AUTOPLAY_DURATION);
	}

	stopAutoplay() {
		if (this.autoPlayInterval) {
			clearInterval(this.autoPlayInterval);
		}
	}

	// Helpers
	displayNumber(number) {
		if (number < 10) {
			return '0' + number;
		}
		return number;
	}


}
